import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchData } from '../../hooks/fetchData';
import { dbDate } from '../../hooks/useCurrentDate';

/*
export const syncSectionScoreThunk = createAsyncThunk(
  'scores/syncSection',
  async ({ section }, thunkAPI) => {
    console.log("start!");
    try {
      
      const state = thunkAPI.getState();
      const userId = state.user.selectedProfile._id
      if (!userId || !section) return;

      const gameStorage =
        JSON.parse(localStorage.getItem('playedGames')) || {};

      const games = gameStorage[section];
      if (!Array.isArray(games)) return;

      const dailyPoints = games.reduce(
        (sum, g) => sum + (Number(g.point) || 0),
        0
      );

      if (dailyPoints === 0) return;

      const response = await fetchData(
        'score',
        'post',
        {
          _id: userId,
          section,
          dailyPoints
        }
      );

      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data);
    }
  }
);
*/

export const syncSectionScoreThunk = createAsyncThunk(
  'scores/syncSection',
  async ({ section, point }, thunkAPI) => {
    console.log("start!");
    try {
      
      const state = thunkAPI.getState();
      const userId = state.user.selectedProfile._id
      if (!userId || !section) return;

      if (point === 0) return;

      const response = await fetchData(
        'score/update',
        'post',
        {
          _id: userId,
          section,
          point
        }
      );

      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data);
    }
  }
);

export const updateProfileGameThunk = createAsyncThunk(
  'game/updateData',
  async ({ userId, profileId, date = dbDate(), score, game, id }, thunkAPI) => {
    try {
      const response = await fetchData(`games/${game}/${id}`, 'post', { userId, profileId, date, score });
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const getProfileGameThunk = createAsyncThunk(
  'game/getData',
  async ({ userId, profileId, date = dbDate(), collection }, thunkAPI) => {
    try {
      const response = await fetchData(`games/data`, 'post', { userId, profileId, date, collection });
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const getTotalScoreThunk = createAsyncThunk(
  'game/getScore',
  async ({ userId, profileId, date = dbDate() }, thunkAPI) => {
    try {
      const response = await fetchData(`games/score`, 'post', { userId, profileId, date });
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);
export const gameSlice = createSlice({
  name: 'game',
  initialState: {
    gameData: {},
    totalScore: 0
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfileGameThunk.fulfilled, (state, action) => {
        state.gameData = action.payload.data || {};
      })
      .addCase(getTotalScoreThunk.fulfilled, (state, action) => {
        state.totalScore = action.payload.score?.totalPoints || 0;
      })
      .addCase(updateProfileGameThunk.fulfilled, (state, action) => {

      })

  },
});

export default gameSlice.reducer;